export enum PurchaseOrderProcesses {
  purchasing = 'PURCHASING',
  // todo: add others
}
